export default __webpack_public_path__ + "6a0cf060b440ab60082b3470993af98f.png";